module.exports = __webpack_public_path__ + "static/media/s4-bottom-extend.a866127c.png";